module.exports = __webpack_public_path__ + "static/media/blue-4.00f14d54.png";